import React from 'react';
import { motion } from 'framer-motion';
import { testimonials } from '../data/content';
function Testimonials() {
  return (
    <section className="pad" id="testimonials">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">Testimonials</span>
          <h2 className="h-section">What clients say</h2>
          <p>I'd rather let the people I've worked with do the talking.</p>
        </div>
        <div className="tst-grid">
          {testimonials.map((t, i) => (
            <motion.div className="tst-card" key={t.name} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }}>
              <p className="tst-quote">{t.quote}</p>
              <div className="tst-author">
                <div className="tst-avatar"><img src={t.avatar} alt={t.name} loading="lazy" /></div>
                <div>
                  <div className="tst-name">{t.name}</div>
                  <div className="tst-role">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
export default Testimonials;
